export const BestOfPrimaryColour: string = '#357D84'
export const BestOfSecondaryColour: string = '#D9F2F4'

export const bestOfRegions = new Set<string>(['AU', 'NZ', 'US', 'SG', 'HK', 'UK'])

export const BestOfCampaignTag: string = 'Best of 2024'
/**
 * Setting certain offers available in the best of for certain regions
 * is done through different campaign tags.
 *
 * This is a mapping of region -> tag
 */
export const BestOfCampaignRegionTags: Record<string, string> = {
  AU: 'Best of 2024 AU',
  NZ: 'Best of 2024 NZ',
  UK: 'Best of 2024 UK',
  HK: 'Best of 2024 HK',
  SG: 'Best of 2024 SG',
  US: 'Best of 2024 US',
}
